import { useRouter } from 'next/router';
import React from 'react';
import DashboardPage from '../../components/Dashboard/DashboardPage';
import Posts from '../../components/Dashboard/Posts';
import withApollo from '../../lib/withApollo';

const PostsPage = () => {
  const router = useRouter();

  const { open } = router.query;

  return (
    <DashboardPage
      open={open}
      bottomNav={2}
      label="posts"
      content={<Posts />}
    />
  );
};

export default withApollo(PostsPage);
